// Keap partner-channel roles get the combined add-on tabs (Keap Add-Ons plus
// one Thryv Add-Ons tab). Core OOE and Proposal keep one tab per group.
const PARTNER_CHANNEL_ROLES = ['keappartner', 'partnerops', 'influencerops']

export const isPartnerChannelRole = role =>
  (Array.isArray(role) ? role : [role]).some(r =>
    PARTNER_CHANNEL_ROLES.includes(String(r ?? '').toLowerCase()),
  )
